var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1454 5.01711H6.47837C4.18837 5.01711 2.33337 6.85211 2.33337 9.11611V14.8841C2.33337 17.1481 4.18937 18.9841 6.47837 18.9841H18.1454C20.4354 18.9841 22.2904 17.1481 22.2904 14.8841V9.11611C22.2904 6.85211 20.4344 5.01611 18.1454 5.01611V5.01711ZM15.3424 12.2801L9.88537 14.8551C9.85209 14.8711 9.81529 14.8785 9.77841 14.8765C9.74152 14.8744 9.70574 14.8631 9.67441 14.8436C9.64307 14.824 9.61719 14.7968 9.59917 14.7646C9.58116 14.7323 9.5716 14.6961 9.57137 14.6591V9.35011C9.57204 9.31299 9.58209 9.27663 9.6006 9.24444C9.6191 9.21224 9.64545 9.18526 9.67719 9.16599C9.70894 9.14673 9.74504 9.13581 9.78214 9.13425C9.81924 9.1327 9.85613 9.14057 9.88937 9.15711L15.3474 11.8921C15.3837 11.9102 15.4142 11.9383 15.4354 11.9729C15.4565 12.0076 15.4675 12.0476 15.467 12.0882C15.4664 12.1288 15.4545 12.1685 15.4324 12.2026C15.4104 12.2367 15.3792 12.2639 15.3424 12.2811V12.2801Z",
    fill: "#E2E8F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.6208a21987d718f9bd4c71d5bfece8a0.svg";
export { ForwardRef as ReactComponent };